// extracted by css-extract-rspack-plugin
export default {"supportChatPlate":"support-chat-plate--fy4DaxjBXJclEcfL","messengers":"messengers--q0REMhfhEhMGrE9e"};